const courses: Record<string, string | number | null> = {
    'featured-course-id': (process.env.FEATURED_COURSE_ID as string) || null
}

export const getCoursesConfig = () => ({ ...courses })
